/* eslint-disable max-len */
import { commonStyleSheet } from 'library/common-styles';
import { ThemeType } from '../../theme/jss-types';

const consignemtStyles = (theme: ThemeType) => ({
    main: {
        width: '100%',
        padding: '5px 6px 6px 5px',
        height: '100%',
    },
    pageFilter: {
        display: 'flex',
        marginBottom: 8,
        borderBottom: '1px solid #D9D9D9',
    },
    pageName: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        color: '#666666',
        padding: '12px 50px',
        cursor: 'pointer',
    },
    selectedPage: {
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        letterSpacing: 0,
        color: theme.primaryColor,
        padding: '12px 50px',
        borderBottom: `4px solid ${theme.primaryColor}`,
    },
    filters: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        height: '100px',
        background: 'white',
        overflowX: 'auto',
    },
    actionButton: {
        marginRight: 4,
    },
    actionButtonDropdown: {
        borderRadius: '6px !important',
        overflow: 'hidden',
        boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.2) !important',
        backgroundColor: 'white',
    },
    count: {
        height: 18,
        padding: 10,
        borderRadius: 9,
        backgroundColor: '#E9E9E9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        fontSize: 12,
        color: '#333',
        fontWeight: 600,
    },
    filter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 16,
    },
    countSelected: {
        backgroundColor: theme.primaryColor,
        color: '#FFF',
        fontWeight: 'bold',
    },
    cellValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0,
        cursor: 'pointer',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    notesCellValue: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0,
        cursor: 'pointer',
    },
    cellNa: {
        color: '#999999',
        fontFamily: 'Open Sans',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0,
    },
    ellipsisIcon: {
        fontSize: 20,
    },
    tabsContainer: {
        width: '998px',
        background: '#ffffff',
        '& .ant-tabs-nav-list': {
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid #f0f0f0',
            minHeight: 42,
        },
        '& .ant-tabs-top > .ant-tabs-nav, .ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-top > div > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav': {
            margin: 0,
            border: 'none',
        },
        '& .ant-tabs-tab': {
            color: '#909090 !important',
            fontWeight: 550,
            fontFamily: 'Open Sans',
            fontSize: 14,
            letterSpacing: 0,
            padding: '2px 18px !important',
            borderRadius: '4px 4px 0 0',
            border: 'none',
            backgroundColor: '#FFFFFF !important',
            cursor: 'pointer',
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: 0,
        },
        '& .ant-tabs > .ant-tabs-nav .ant-tabs-nav-more': {
            padding: '0px 16px !important',
        },
    },
    dateFilter: {
        width: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        justifyContent: 'end',
        '& .ant-picker': {
            borderRadius: '6px',
            width: 215,
            height: 32,
        },
        '& .ant-picker-input > input': {
            fontSize: '13px',
        },
    },
    filterContainer: {
        position: 'relative',
    },
    selectFilter: {
        marginRight: '12px !important',
        width: '150px',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
        },
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '6px !important',
            alignItems: 'center',
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 600,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
    },
    selectFilterWide: {
        marginRight: '12px !important',
        flex: '0 0 220px',
        maxWidth: 280,
        minWidth: 200,
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
        },
        '& .ant-select-selector': {
            width: '100% !important',
            borderRadius: '6px !important',
            alignItems: 'center',
            minHeight: '32px',
            padding: '0 12px !important',
        },
        '& .ant-select-arrow': {
            right: 10,
        },
        '& .ant-picker': {
            width: '100% !important',
        },
    },
    rangeFilter: {
        flex: '0 0 220px',
        maxWidth: 280,
        minWidth: 200,
        marginRight: '12px !important',
        '& .ant-picker': {
            width: '100% !important',
        },
    },

    dateTypeSelect: {
        marginRight: '12px !important',
        width: '130px',
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '6px !important',
            alignItems: 'center',
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 600,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
    },
    searchSelect: {
        margin: '0 !important',
        width: '234px',
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '4px 0 0 4px !important',
            alignItems: 'center',
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 600,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
    },
    mobileSearch: {
        borderRadius: '6px 6px 6px 6px !important',
        marginRight: 12,
        width: '100%',
    },
    search: {
        borderRadius: '0 4px 4px 0 !important',
        marginRight: 12,
        width: '234px',
    },
    footer: {
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
            height: '22px !important',
        },
    },
    paginationGroup: {
        direction: 'ltr',
        display: 'flex',
        fontSize: 12,
    },
    resultPerPage: {
        margin: '0 5px !important',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
        },
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '6px !important',
            alignItems: 'center',
            fontSize: 12,
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 550,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
        '& .ant-select-selection-item': {
            fontWeight: '550 !important',
        },
    },
    finalPrice: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 13,
        fontWeight: 500,
        letterSpacing: 0,
        cursor: 'pointer',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    bucket: {
        color: '#666666',
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        padding: '6px 12px',
        marginRight: 2,
        borderRadius: '4px 4px 0 0',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    resetFilter: {
        color: '#DF1D1D',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        marginLeft: 16,
        fontFamily: 'Open Sans',
    },
    bucketRow: {
        '& .ant-tabs-nav-operations': {
            width: 'auto',
            fontSize: 18,
            backgroundColor: '#ffffff',
        },
        '& .ant-tabs-nav-operations::after': {
            display: 'none !important',
            content: 'none !important',
        },
    },
    extraFilters: {
        width: '100%',
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFFFF',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        flexDirection: 'row',
    },
    leftFilters: {
        display: 'flex',
        alignItems: 'center',
        '& > *': {
            marginRight: 12,
        },
        '& > *:last-child': {
            marginRight: 0,
        },
    },
    rightFilters: {
        display: 'flex',
        alignItems: 'center',
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 30,
            borderRadius: 4,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor} `,
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
        },
        '& .ant-dropdown-menu-submenu-title': {
            padding: '12px 4px',
        },
    },
    downloadBtn: {
        marginRight: 12,
    },
    settingIcon: {
        color: '#333333',
        fontSize: 20,
        cursor: 'pointer',
        marginLeft: 4,
    },
    menu: {
        fontSize: 14,
        fontWeight: 'bold',
    },
    modalContainer: {
        padding: '1rem 0',
        paddingBottom: '3rem',
        minWidth: '40%',
    },
    carouselContainer: {
        padding: '1.5rem',
        maxWidth: '100%',
        '& span': {
            color: '#222021 !important',
        },
        '& span > svg': {
            width: '120%',
            height: '120%',
        },
    },
    popupbox: {
        backgroundColor: 'white',
        padding: '0px',
        borderRadius: '4px',
    },
    popupheader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#10477C',
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '19px',
        padding: '14px',
    },
    modal: {
        '& .ant-modal-mask': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        '& .ant-modal-header': {
            backgroundColor: '#082E78',
            borderRadius: '4px 4px 0 0',
        },
        '& .ant-modal-title, .ant-modal-close-x': {
            color: '#FFFFFF',
        },
        '& .ant-modal-content': {
            borderRadius: 4,
            boxShadow: 'none !important',
        },
        '& .ant-modal-body': {
            padding: '0px !important',
        },
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    horizontalline: {
        height: '1px',
        backgroundColor: '#CCCCCC',
    },
    modalBody: {
        padding: '8px',
        fontSize: '13px !important',
        minWidth: 450,
    },
    uploadText: {
        color: '#111111',
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 32,
    },
    uploadHint: {
        fontSize: 16,
        color: '#666666',
    },
    modalfooter: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    mdbutton: {
        borderRadius: '2px',
        border: '0 !important',
        margin: '6px 8px',
        fontWeight: 500,
        minHeight: '36px',
        minWidth: '88px',
        textAlign: 'center',
        verticalAlign: 'middle',
        padidng: '0 8px',
    },
    dropdown: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap-reverse',
        alignItems: 'center',
    },
    grayCircle: {
        width: '32px',
        height: '32px',
        fontSize: '14px',
        backgroundColor: '#F5F5F5',
        borderRadius: '64px',
        marginRight: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    customFlex: {
        display: 'flex', alignItems: 'center',
    },
    dateRange: {
        '& .ant-picker-cell-in-view::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-cell:hover .ant-picker-cell-in-view:hover::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-panel-container': {
            backgroundColor: '#f7f7f7 !important',
            borderRadius: '4px !important',
            display: 'flex !important',
            flexDirection: 'row-reverse !important',
        },
        '& .ant-picker-cell-in-view .ant-picker-cell-inner': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            width: '32px !important',
            height: '32px !important',
            padding: '0 !important',
            backgroundColor: 'white !important',
            borderRadius: '4px !important',
            margin: '1px !important',
            boxSizing: 'border-box !important',
            '&:hover': {
                backgroundColor: '#b9e0ff !important',
            },
        },
        '& .ant-picker-cell-in-view': {
            padding: '0 !important',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.secondaryFillColor} !important`,
            borderColor: `${theme.secondaryFillColor} !important`,
            fontWeight: 'bold !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-disabled::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-footer': {
            minWidth: 140,
            padding: 4,
        },
        '& .ant-picker-ranges .ant-picker-preset > .ant-tag-blue': {
            color: 'black',
            background: 'transparent !important',
            borderColor: 'transparent !important',
            fontWeight: 600,
            fontSize: '12px',
            padding: '8px',
        },
        '& .ant-picker-ranges > li:hover': {
            display: 'inline-block',
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            borderRadius: '4px',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner': {
        },
    },
});

export {
    consignemtStyles,
};
